import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'RELATORIO_HOSPITAL_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'RELATORIO_HOSPITAL_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getLista(filtro = {}) {
	return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/laudoImportacao/relatorioHospital?ano=${filtro.ano || 0}&mes=${filtro.mes || 0}&id_hospital=${filtro.id_hospital || 0}`
		).then(resp => {
			dispatch({
				type: 'RELATORIO_HOSPITAL_LISTADO',
				payload: resp
			});			
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaProducao(filtro = {}) {
	return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/laudoImportacao/relatorioHospitalProducao?ano=${filtro.ano || 0}&mes=${filtro.mes || 0}&id_hospital=${filtro.id_hospital || 0}`
		).then(resp => {
			dispatch({
				type: 'RELATORIO_HOSPITAL_PRODUCAO_LISTADO',
				payload: resp
			});			
		}).catch(e => {
			setErroAPI(e);
		});
	}
}
